import React from 'react';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section className="border-y border-ink-line bg-ink-soft px-5 py-20 md:py-28" data-id="element-168" data-mp="2lmspkkrd14js">
      <div className="mx-auto grid max-w-6xl items-center gap-12 md:grid-cols-2 md:gap-16" data-id="element-169" data-mp="26xehrh3fmv6i">
        <div data-id="element-170" data-mp="2bwh9jzuej4wj">
          <h2 className="font-display text-4xl uppercase leading-none text-cream md:text-6xl" data-id="element-171" data-mp="2bw7s50nfa62g">
            Enseigner le jazz ne devrait pas <span className="text-gold" data-id="element-172" data-mp="1xzuddza9wiro">vous épuiser</span>
          </h2>
          <p className="mt-6 font-serif text-lg italic text-cream-muted" data-id="element-173" data-mp="220we6kju92vr">
            Si vous vous reconnaissez dans l’une de ces situations, ce pack a été conçu pour vous.
          </p>
          <ul className="mt-8 divide-y divide-ink-line border-y border-ink-line" data-id="element-174" data-mp="1szpxaada1q1z">
            {painPoints.map(p => <li key={p} className="flex gap-4 py-4 text-cream/90" data-id="element-175" data-mp="3iee5s0iqynuq">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-176" data-mp="3nbmpi5jjmzy3" />
                {p}
              </li>)}
          </ul>
        </div>
        <figure className="relative" data-id="element-177" data-mp="1u1tyit6ogigv">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/8b6c0d3e-e380-45ca-9a7a-c74bffe4abac.jpg" alt="Professeur de guitare jazz dans son studio" loading="lazy" className="aspect-[4/5] w-full rounded-2xl object-cover sm:aspect-[4/5]" data-id="element-178" data-mp="1u0smomhu7ry3" />
          <figcaption className="absolute bottom-3 left-3 right-3 rounded-xl bg-ink/90 p-4 font-serif text-[15px] italic text-cream sm:bottom-5 sm:left-5 sm:right-5 sm:p-5 sm:text-base" data-id="element-179" data-mp="1g2cess88nved">
            « J’aurais aimé avoir ce système dès ma première année d’enseignement. »
          </figcaption>
        </figure>
      </div>
    </section>;
}